module.exports = __webpack_public_path__ + "assets/fonts/opensans-semibolditalic-webfont.woff";